import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./features.css";

const FeatureData = [
  {
    title: "Murojat va Fikrlar",
    desc: "O'z fikringiz yoki murojatlaringiz haqida bizga malumot bermoqchi bo'lsangiz pastda ko'rsatilgan telefon raqam yoki emailga murojat qiling.",
    phone: "+998 (90)428 90 40",
    email:"azamatmavlonov286@gmail.com",
    icon: "ri-draft-line",
  },

  {
    title: "Ma'lumotlar masuli",
    desc: "Web site ma'lumotlari masuli Qarshi Davlat muhandislik Universitet Kimyoviy texnologiya kafedrasi katta o'qituvchisi Tavashov Shahzod ",
    phone: "+998 (91)456 26 66",
    email:"t_shahzod@mail.ru",
    icon: "ri-discuss-line",
  },

  {
    title: "Web site Developer",
    desc: "Web site yaratuvchisi frontend developer,shikoyat yoki muhim fikrlar uchun pastda ko'rsatilgan telefon raqam yoki emailga bog'laning",
    phone: "+1(760)222 66 26",
    email:"webdeveloper477@icloud.com",
    icon: "ri-contacts-book-line",
  },
];

const Features = () => {
  return (
    <section>
      <Container>
        <Row>
          {FeatureData.map((item, index) => (
            <Col lg="4" md="6" key={index}>
              <div className="single__feature text-center px-4">
                <h2 className="mb-3">
                  <i class={item.icon}></i>
                </h2>
                <h6>{item.title}</h6>
                <p>{item.desc}</p>
                <p>{item.phone}</p>
                <a href="https://mail.ru/">{item.email}</a>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
